<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Uploading Custom PSI</h1>
      <p>
        Just like in the KPIs, by clicking <b><i class="fas fa-plus-circle"/> Upload Custom PSI</b> button on the sidebar,
        a dialog will appear which - again - has two fields: file upload, and name for the set of KPIs. When you
        <b>upload a file</b> you will be informed about the <b>validity of the headers</b> of the CSV file.
      </p>

      <div class="image-container">
        <img src="@/images/manual/upload-psis-bad.png" alt="clone project button" />
        <div class="img-caption">
          Figure 1. Invalid PSIs Uploaded
        </div>
      </div>

      <p>
        Just like in the KPIs, if the CSV file contains <b>no errors</b> the user should see no informative messages at all.
      </p>

      <div class="image-container">
        <img src="@/images/manual/upload-psis-good.png" alt="clone project button" />
        <div class="img-caption">
          Figure 2. Valid PSIs Uploaded
        </div>
      </div>

      <p>
        Users are able to download a template with the valid headers of a CSV file containing PSIs.
        The following list shows the <b>valid headers</b> contained in such files.
      </p>
      <div class="ml-5">
        <ul>
          <li>PSI (text)</li>
          <li>Functional Unit (text)</li>
          <li>Call Impact</li>
          <li>Target Value (double number)</li>
          <li>Value (double number)</li>
          <li>Failed (double number)</li>
          <li>Underachieved (double number)</li>
          <li>Achieved (double number)</li>
          <li>Overachieved (double number)</li>
        </ul>
      </div>

      <br />

      <p><b>Important note:</b> The template is provided in XLSX format (Excel file) for the user's convenience. However,
        before uploading it to USE, the file must be converted to <b>CSV</b> using the <b>semicolon symbol (;)</b> as delimiter.
      </p>

    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>
img {
  height: 66% !important;
  width: 66% !important;
}
</style>